import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthProvider';

const ProtectedRoute = ({ children }) => {
    const { isAuthenticated, planId, loading } = useAuth();
    const location = useLocation();

    if (loading) return null; // or a loading spinner if desired
    // return isAuthenticated ? <Component /> : <Navigate to="/login" />;
    // return isAuthenticated ? children : <Navigate to="/login" />;

    if (!isAuthenticated) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if ((!planId || planId === 'invalid') && location.pathname !== '/choose-plan') {
        return <Navigate to="/choose-plan" state={{ from: location }} replace />;
    }

    return children;
};

export default ProtectedRoute;
